import { AxiosPromise } from "axios";

import { ISMS, ISMSAudienceTotals, ISMSFilters, ISMSInput, ISMSListing } from "modules/sms/models";
import { SparrowApi } from "./network/adapters/SparrowApi";
import { ApiRequest } from "./network";

export class SMSApi {
    constructor(private _sparrowApi: SparrowApi) {}

    createNewSMS(sms: ISMS): AxiosPromise<ISMS> {
        const body: ISMSInput = {
            ...sms,
            audiences: sms.audiences.map(a => a.id),
            sentTime: sms.sentTime && new Date(sms.sentTime) >= new Date() ? sms.sentTime : undefined
        };

        return new ApiRequest<ISMS>(
            this._sparrowApi.TenantRequest().post(`/{tenant}/adminapi/v2/notifications/sms/new`, body)
        ).catch((err) => {
            throw err;
        });
    }

    saveExistingSMS(sms: ISMS): AxiosPromise<ISMS> {
        const body: ISMSInput = {
            ...sms,
            audiences: sms.audiences.map(a => a.id),
            sentTime: sms.sentTime && new Date(sms.sentTime) >= new Date() ? sms.sentTime : undefined
        };

        return new ApiRequest<ISMS>(
            this._sparrowApi.TenantRequest().put(`/{tenant}/adminapi/v2/notifications/sms/${sms.id}`, body)
        ).catch((err) => {
            throw err;
        });
    }

    getSMS(smsId: string): AxiosPromise<ISMS> {
        return new ApiRequest<ISMS>(
            this._sparrowApi.TenantRequest().get(`/{tenant}/adminapi/v2/notifications/sms/${smsId}`)
        ).catch((err) => {
            throw err;
        });
    }

    
    deleteSMS(smsId: string): AxiosPromise<void> {
        return new ApiRequest(
            this._sparrowApi.TenantRequest().delete(`/{tenant}/adminapi/v2/notifications/sms/${smsId}`)
        ).catch((err) => {
            throw err;
        });
    }

    getAudienceTotals(audienceIds: string[], sendToAllUsers: boolean, targetOptedInUsers: boolean = true): AxiosPromise<ISMSAudienceTotals> {
        return new ApiRequest<ISMS>(
            this._sparrowApi.TenantRequest().post(`/{tenant}/adminapi/v2/notifications/sms/audienceTotals?allUsers=${sendToAllUsers}&targetOptedInUsers=${targetOptedInUsers}`, audienceIds)
        ).catch((err) => {
            throw err;
        });
    }

    getAudienceTotalCSV(audienceIds: string[], sendToAllUsers: boolean, targetOptedInUsers: boolean = true): AxiosPromise<string> {
        return new ApiRequest<ISMS>(
            this._sparrowApi.TenantRequest().post(`/{tenant}/adminapi/v2/notifications/sms/audienceTotals/download?allUsers=${sendToAllUsers}&targetOptedInUsers=${targetOptedInUsers}`, audienceIds)
        ).catch((err) => {
            throw err;
        });
    }

    sendTestSMS(smsId: string, targetNumbers: string[]) {
        return new ApiRequest<ISMS>(
            this._sparrowApi.TenantRequest().post(`/{tenant}/adminapi/v2/notifications/sms/${smsId}/testSend`, targetNumbers)
        ).catch((err) => {
            throw err;
        });
    }

    sendSMS(smsId: string) : AxiosPromise<void> {
        return new ApiRequest<ISMS>(
            this._sparrowApi.TenantRequest().post(`/{tenant}/adminapi/v2/notifications/sms/${smsId}/send`)
        ).catch((err) => {
            throw err;
        });
    }

    getSMSList(pageAmount: number, pageNumber: number, filters: ISMSFilters): AxiosPromise<ISMSListing> {
        return new ApiRequest<ISMSListing>(
            this._sparrowApi.TenantRequest()
                .post(
                    `/{tenant}/adminapi/v2/notifications/sms/paged?pageNumber=${pageNumber}&pageAmount=${pageAmount}`,
                    filters
                )
        ).catch((err) => {
            throw err;
        });
    }

    cloneSMS(smsId: string): AxiosPromise<string> {
        return new ApiRequest<string>(
            this._sparrowApi.TenantRequest().post(`/{tenant}/adminapi/v2/notifications/sms/${smsId}/clone`)
        ).catch((err) => {
            throw err;
        });
    }

    cancelSend(smsId: string): AxiosPromise<string> {
        return new ApiRequest<string>(
            this._sparrowApi.TenantRequest().post(`/{tenant}/adminapi/v2/notifications/sms/${smsId}/cancelSend`)
        ).catch((err) => {
            throw err;
        });
    }
}
